import React from 'react';

/**
 * Permite asignar múltiples refs.
 * 
 * @example
 * 
 *  const CA = React.forwardRef((_, ref) => {
    const innerRef = React.useRef<HTMLElement>(null);
    const setRefs = useMultipleRefs(
      ref as React.MutableRefObject<unknown>,
      innerRef,
    );

    React.useEffect(() => {
      console.log(ref, innerRef);
    });

    return <Box ref={setRefs}>Hola mundo</Box>;
});
 */
export default function useMultipleRefs<T extends HTMLElement | null>(
  ...refs: React.MutableRefObject<T>[]
) {
  return React.useCallback(
    function setRef(element: T) {
      refs.forEach((current) => {
        // eslint-disable-next-line no-param-reassign
        if (current) current.current = element;
      });
    },
    [refs],
  );
}
